<template>
  <div class="creatMusBox">
    <div class="musCrTit">用文字释放你的艺术创造力</div>

    <div class="musTipTextBox" @click="createMusicDemo(sampleList[0],0)">
      <div class="musTipText">{{  sampleList[0].prompt}}</div>
      <!-- ./img/crIcon.png -->
      <img class="crImg" src="./img/crIcon.png" />
    </div>
    <div class="crTexarBox">
      <!-- trigger="focus" -->
      <el-popover
        v-model="isSemShow"
        popper-class="crlistPop"
        :visible-arrow="visibleArrow"
      >
        <template #reference v-if="!isLogin||!userInfo.is_vip">
          <textarea
            class="crTexar"
            @focus="remmFocus"
            @blur="remmBlur"
            v-model="createForm.desc"
            readonly
            placeholder="输入绘画描述，比如：国漫风，高冷少年，剑星眉目，帅气，古风美女，薄纱外套"
          >
          </textarea>
        </template>
        <template #reference v-else>
          <textarea
            class="crTexar"
            @focus="remmFocus"
            @blur="remmBlur"
            v-model="createForm.desc"
            placeholder="输入绘画描述，比如：国漫风，高冷少年，剑星眉目，帅气，古风美女，薄纱外套"
          >
          </textarea>
        </template>
        <!-- v-show="isSemShow" -->
        <div class="sempList" v-show="isSemShow">
          <div class="recommend_top">
            <img src="./img/recommend.png" alt="" />
            <span
              >（游客可<span class="free_text">免费体验</span
              >一次，成为会员后可自由输入）</span
            >
          </div>
          <div
            class="sempItem"
            v-for="(item,index) in sampleList"
            @click="createMusicDemo(item,index)"
            :key="item.id"
          >
            <!-- /img/music_icon.png -->
            <img class="sempImg" src="./img/header/icon_img1.png" alt="" />
            <div class="sempName">{{ item.prompt }}</div>
          </div>
        </div>
      </el-popover>
    </div>

    <div class="create_btn" @click="createMusic">
      开始创作
      <!-- <div class="primary_btn" @click="createMusic" v-loading="createLoading">
                <div>
                    <span>开始创作 </span><span class="iconfont icon-yinlefuhao"></span>
                </div>
            </div> -->
    </div>

    <div class="creatDetail">
      <div class="creatAll">昨日画：{{ total_num }} 张</div>
      <div class="creatToday">{{currentMonth}}月{{currentDate}}日画：{{ docnum }} 张</div>
    </div>

    <div class="objPCBox">
      <!-- ./img/labaImg.gif -->
      <img class="labaIcon" src="./img/labaImg.gif" />
      <div class="PCInt">MJ绘画，电脑端网址：www.midjournny.cn</div>
    </div>
  </div>
</template>

<script>
import utils from '@/utils/index.js'
    export default {
        data(){
            return{
                recommend_list:[],
                total_num:0,
                docnum:0,
                createLoading:false,
                isSemShow:false,
                createForm:{
                    desc:''
                },
                currentNa:null,
                visibleArrow:false,
                sampleList:[
                    {prompt:''}
                ],
                currentMonth:0,
                currentDate:0,
                SITE_BTN_CONFIG:SITE_BTN_CONFIG,

            }
        },
        created() {
            let date = new Date();
            let month = date.getMonth()+1;
            let day = date.getDate();
            this.todayText = month + "月" + day + "日";
            const now = new Date();
            this.currentMonth = now.getMonth() + 1; // getMonth() 返回的月份是从 0 开始的，所以需要加 1
            this.currentDate = now.getDate();
                
            this.totalDongHua()
        },
        methods:{
            checkPower(){
                if(!this.isLogin){
                    this.createForm.desc = ''
                    return
                }
            },
            totalDongHua(){
            this.$http.get(`/front/aimj/draw/num/`).then((res) => {
              this.total_num = res.data.total_num;
              this.total_num = Math.floor(Math.random() * 500) + res.data.today_doc_num;
              let today_doc_num = res.data.today_doc_num;

              let step = parseInt(today_doc_num/20);
              let timer = setInterval(()=>{
                this.docnum = this.docnum + step;
                if(this.docnum > today_doc_num){
                  this.docnum = today_doc_num;
                  clearInterval(timer);
                }
              },100)
            })
          },
            fettchSampleList () {
                // 获取样例数据
                // this.$http.get('/front/aimj/draw/sample/', { params: { max_mj_id: this.max_mj_id } }).then((res) => {
                //     this.sampleList = res.data.item_list;
                // })
              console.log('获取样例数据')
              this.$http.get('/front/aimj/draw/sample/', {
                params: {
                  draw_soft:'mj',
                  page: this.page,
                  size: 10,
                  // max_mj_id: this.max_mj_id,
                  // page: this.page,
                  // bd_vid: bd_vid,
                  // qhclickid: qhclickid,
                  // sourceid: sourceid,
                  // ad_account_id: ad_account_id
                }
              }).then((res) => {
                this.sampleList= res.data

                console.log(this.sampleList)
              })
            },
            createMusic(){
            // console.log(this.SITE_BTN_CONFIG); return
                if(!utils.setOptData(this.userInfo,'btn_mj_create')){
                    return
                }
                if(!this.createForm.desc.trim().length){
                    this.$message.warning('请填写描述词')
                    return
                }
                localStorage.setItem('semText',this.createForm.desc)
                // localStorage.setItem('sampleUserList',JSON.stringify([this.sampleList[this.currentNa]]))
                localStorage.setItem('sampleNa',this.currentNa)
                this.$router.push('/creation')
                // if(!this.isLogin){
                //     // if(localStorage.getItem('sampleUserList')){
                //     //     this.$store.commit('setShowLogin', true)
                //     //     return
                //     // }else{
                //         if(!this.createForm.desc.trim().length){
                //             this.$message.warning('请填写描述词')
                //             return
                //         }
                //         if(this.currentNa==null){
                //             localStorage.setItem('semText',this.createForm.desc)
                //             this.$router.push('/creation')
                //         }else{
                //             localStorage.setItem('sampleUserList',JSON.stringify([this.sampleList[this.currentNa]]))
                //             this.$router.push('/creation')
                //         }
                //     // }
                // }else{

                //         if(!this.createForm.desc.trim().length){
                //             this.$message.warning('请填写描述词')
                //             return
                //         }
                //         localStorage.setItem('semText',this.createForm.desc)
                //         this.$router.push('/creation')
                // }

            },
            createMusicDemo(data,cur){
                this.currentNa = cur
                this.createForm.desc = data.prompt
            },
            remmFocus() {
      setTimeout(() => {
        if (this.userInfo == 0) {
          this.isSemShow = true;
        }
      });
    },
    remmBlur() {
      setTimeout(() => {
        this.isSemShow = false;
      });
    },
        },
        computed:{
            tips_list(){
                return this.sampleList.slice(this.sampleList.length - 20, this.sampleList.length)
            },
            userInfo() {
                return this.$store.state.userInfo;
            },
            isLogin() {
                return this.$store.state.isLogin;
            }
        },
        mounted(){
            this.fettchSampleList()
        }
    }
</script>

<style lang="scss" scoped>
.creatMusBox {
  width: 100%;
  background: #1d2027;
  box-sizing: border-box;
//   padding: 0 10px;
  overflow: hidden;

  .musCrTit {
    font-size: 25px;
    font-weight: 600;
    margin-top: 20px;
    	/* 设置文字颜色为透明 */
		color: transparent;
		/* 使用背景渐变 */
		background-image: linear-gradient(to right, #8a2cfb, #0ef6ec);
		/* 将背景裁剪为文字 */
		-webkit-background-clip: text;
		background-clip: text;
  }

  .musTipTextBox {
    width: 100%;
    border-radius: 6px;
    padding: 20px 5px 20px;
    color: #fff;
    background: linear-gradient(to bottom, #1d2027, #2b2d31);
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    box-shadow: 1px 19px 14px -1px rgba(0, 0, 0, 0.1019607843),
      0 2px 4px -1px rgba(0, 0, 0, 0.0588235294);
    .musTipText {
      width: 88%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    // justify-content: space-between;
    .crImg {
      width: 20px;
      height: 20px;
      margin-left: 5px;
      // margin-right: 10px;
    }
  }
  .crTexarBox {
    // position: relative;
    width: 100%;
    textarea::-webkit-input-placeholder {
      color: #999;
    }

    input:-moz-placeholder {
      color: #999;
    }

    input::-moz-placeholder {
      color: #999;
    }

    input:-ms-input-placeholder {
      color: #999;
    }
    .crTexar {
      width: 100%;
      background: #37393f;
      font-size: 14px;
      padding: 5px;
      border: 1px solid #4c4c4c;
      min-height: 60px;
      border-radius: 6px;
      margin-top: 10px;
      color: #999;
    }
  }
  .create_btn {
    width: 100%;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50px;
    color: #fff;
    margin: 10px auto;
    background: #5865f2;
  }

  // .create_btn {
  //     box-sizing: border-box;
  //     width: 100%;
  //     margin: 10px 0;
  //     z-index: 1;
  //     overflow: hidden;
  //     position: relative;

  //     .primary_btn {
  //         width: 100%;
  //         display: flex;
  //         flex-direction: column;
  //         padding: 20px 0;
  //         height: auto;
  //         font-weight: bold;
  //         font-size: 16px;
  //         border-radius: 4px;
  //         // background-image: url(./img/create-button-background.svg) !important;
  //         background-size: cover;
  //         background-position: center;
  //         // transition: background 1s ease-in-out;
  //         overflow: hidden;
  //         color: #fff;
  //     }

  //     // .primary_btn:before {
  //     //     overflow: hidden;
  //     //     content: '';
  //     //     position: absolute;
  //     //     top: 0;
  //     //     left: 0;
  //     //     width: 100%;
  //     //     height: 100%;
  //     //     // background-image: url(./img/grain.png);
  //     //     background-size: cover;
  //     //     background-repeat: repeat;
  //     //     background-color: transparent !important;
  //     //     opacity: 0.5;
  //     //     z-index: 1;
  //     //     pointer-events: none;
  //     // }
  // }

  .creatDetail {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 20px 0;
    white-space: nowrap;

    .creatAll {
      color: #878787;
      font-size: 16px;
    }

    .creatToday {
      font-size: 16px;
      color: #5865f2;
    }
  }

  .objPCBox {
    // width: calc(100% + 40px);
    display: flex;
    align-items: center;
    background: #4e5058;
    padding: 10px;
    // margin-left: -10px;
    margin-bottom: 20px;
    border-radius: 6px;

    .labaIcon {
      width: 20px;
      height: 20px;
    }

    .PCInt {
      margin-left: 10px;
    //   font-weight: 200;
      white-space: nowrap;
    }
  }
}

</style>

<style lang="scss">
.crlistPop {
  width: calc(100% - 10px) !important;
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
  .el-popper__arrow {
    display: none;
  }
  .sempList {
    // position: absolute;
    // left: 0;
    // bottom: -180%;
    // width: 100vw;
    background: #000;
    padding: 10px;
    border-radius: 6px;
    z-index: 999;
    .recommend_top {
      display: flex;
      align-items: center;

      .free_text {
        color: rgb(251, 156, 141);
      }
    }
    .sempItem {
      display: flex;
      align-items: center;
      margin: 10px 0;
      .sempImg {
        font-size: 0;
        width: 20px;
        height: 20px;
      }
      .sempName {
        color: #606266;
        margin-left: 10px;
        width: 88%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>